import { useEffect, useState } from 'react';
import { Upload as UploadAnt, Modal } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { styled } from '@stitches/configed';
import { message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Photo } from '../../../services/attachment';
import {
  UploadFile,
  UploadProps as UploadPropsAntd,
} from 'antd/lib/upload/interface';
import { authHeader } from '../../../services/api';
import ImgCrop from 'antd-img-crop';
import { UploadProps as UploadPropsRcUpload } from 'rc-upload/lib/interface';
function getBase64(img: RcFile, callback: (r: string) => void) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
}
const UploadWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  '@xs': {
    flexDirection: 'row',
  },

  '& > div + div': {
    marginTop: 16,
    '@xs': {
      marginTop: 0,
      marginLeft: 16,
    },
  },
});

type UploadProps = UploadPropsAntd &
  Pick<UploadPropsRcUpload, 'onProgress' | 'onError' | 'onSuccess'>;
type Props = UploadProps & {
  role: 'customer' | 'shipper' | 'merchant' | 'admin';
  crop?: boolean;
  initialValue?: Photo[];
  width?: number;
  height?: number;
  onChange?: (fileList: Photo[]) => void;
  onSuccess?: () => void;
};
const Upload = ({
  role,
  crop,
  initialValue,
  width,
  height,
  style,
  onChange,
  onSuccess,
  ...props
}: Props) => {
  const [messageApi, contextHolder] = message.useMessage();

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [photoList, setPhotoList] = useState<Photo[]>([]);

  function beforeUpload(file: RcFile) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      messageApi.error('Tệp phải có định dạng JPG/PNG!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      messageApi.error('Hình ảnh phải nhỏ hơn 2MB!');
    }
    if (!isJpgOrPng || !isLt2M) return false;

    return true;
  }

  useEffect(() => {
    if (initialValue) {
      setFileList(
        initialValue.map((x, i) => {
          return {
            uid: i.toString(),
            status: 'done',
            name: x.image,
            url: x.image,
          };
        }),
      );
    }
  }, [initialValue]);

  const handlePreview = async (file: UploadFile) => {
    getBase64(file.originFileObj as RcFile, (imageUrl) => {
      if (imageUrl) {
        setPreviewImage(imageUrl);
        setPreviewOpen(true);
        setPreviewTitle(
          file.name || imageUrl.substring(imageUrl.lastIndexOf('/') + 1) || '',
        );
      }
    });
  };
  const handleChange: UploadProps['onChange'] = ({
    fileList: newFileList,
    file,
  }) => {
    setFileList(newFileList);
    if (onChange) {
      onChange(
        newFileList
          .map((x) => {
            return {
              image: x.url || '',
              thumbnail: x.thumbUrl || '',
            };
          })
          .filter((x) => x.image && x.thumbnail),
      );
    }
  };
  const handleSuccess: UploadProps['onSuccess'] = (response, file) => {
    const photo = response.data as Photo;
    const newFileList = [...photoList, photo];
    setPhotoList(newFileList);

    const lastItem = fileList.pop();
    if (lastItem) {
      const newFile: UploadFile = {
        ...lastItem,
        status: 'done',
        url: photo.image,
        thumbUrl: photo.thumbnail,
      };
      handleChange({ fileList: [...fileList, newFile], file: newFile });
      onSuccess && onSuccess();
    }
  };

  const UploadComponent = (
    <UploadAnt
      accept=".jpg,.png"
      action={`${
        process.env.REACT_APP_API_UPLOAD_URL || 'http://localhost:3000'
      }/upload/${role}/photo`}
      headers={authHeader()}
      beforeUpload={beforeUpload}
      listType="picture-card"
      fileList={fileList}
      onPreview={handlePreview}
      onChange={handleChange}
      onSuccess={handleSuccess}
      {...props}
    >
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8, marginBottom: 8 }}>Tải ảnh</div>
        <div>- Dung lượng tối đa 2MB</div>
        <div>- Định dạng .jpg, .png</div>
      </div>
    </UploadAnt>
  );

  return (
    <UploadWrapper style={style}>
      {contextHolder}
      {crop ? (
        <ImgCrop
          modalTitle="Chỉnh sửa hình ảnh"
          aspect={width && height && width / height}
        >
          {UploadComponent}
        </ImgCrop>
      ) : (
        UploadComponent
      )}
      <Modal
        centered
        visible={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={() => {
          setPreviewOpen(false);
        }}
      >
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </UploadWrapper>
  );
};

export default Upload;
